/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M23.5159 1.5598c-3.9019-1.97-8.5361-1.537-11.9842 1.0064l-.282-.0823c-2.952-.8622-5.4547.5542-7.1571 1.6557l-.7149.4625.5476.652L6.03 7.7597l-4.8672 4.7231 7.735 9.2087 5.4925-3.9788 2.1045 2.5055.5476.652.579-.6243c1.3789-1.4866 3.2062-3.7071 2.8666-6.7638l-.0324-.2918c3.1005-2.9572 4.3271-7.447 3.0604-11.6305Zm-4.4922 12.7964-3.413 2.4724 1.4773 1.7588c1.0106-1.1823 1.8897-2.5542 1.9357-4.2312ZM5.6342 4.9512c1.339-.7912 2.8421-1.4203 4.5019-1.176L7.1116 6.71 5.6342 4.9512Zm3.5146 14.7021 9.233-6.6884c3.2668-2.3665 4.7699-6.4507 3.8642-10.3384-3.6731-1.5633-7.9554-.788-10.8504 2.0212l-8.182 7.9395 5.9352 7.0661Zm-3.7526 1.2278L4.4294 19.73l-1.9338-2.3022-.9669-1.1511a3.6288 3.6288 0 0 0-1.2813 2.4645l-.108 1.2407-.1302 1.4976 1.4976.1303 1.2407.1079a3.629 3.629 0 0 0 2.6487-.8366Zm-2.5184-.661L1.745 18.8715l-.1079 1.2406 1.2407.108ZM17.508 8.5695c-.6357.534-1.5839.4515-2.1179-.1842s-.4515-1.584.1842-2.118c.6357-.534 1.584-.4515 2.1179.1843.534.6357.4516 1.584-.1842 2.118Zm.9669 1.1511c-1.2715 1.068-3.1679.903-4.2359-.3684-1.068-1.2715-.9031-3.168.3684-4.236 1.2715-1.068 3.168-.903 4.2359.3685 1.068 1.2714.9031 3.168-.3684 4.236Z"
    clipRule="evenodd"
  />,
  'Deploy'
);
